import type { AccountWorkflowPayload } from '@Application/SubjectTypeDefinitions/Actions/accountWorkflowsFetched';

class AccountWorkflowView {
	readonly key: string;
	readonly label: string;
	readonly launchMode: string;
	readonly launchModeLabel: string;
	readonly isActive: boolean;

	constructor(payload: AccountWorkflowPayload) {
		this.key = payload.key;
		this.label = payload.label;
		this.launchMode = payload.launchMode.value;
		this.launchModeLabel = payload.launchMode.label;
		this.isActive = payload.isActive;

		Object.freeze(this);
	}

	get isAutomatic(): boolean {
		return this.launchMode === 'automatic';
	}
}

export default AccountWorkflowView;
